import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import { StyledSearchIcon } from '../../../Campaigns/Campaigns.styles';

export const StyledTextField = styled(TextField)`
    && {
        .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
            padding-left: 32px;
        }
    }
`;

export const SearchIcon = styled(StyledSearchIcon)`
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
`;

export const InputWrapper = styled.div`
    position: relative;
`;

export const SaveButton = styled.button`
    height: 44px;
    outline: none;
    border: 0;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    text-transform: uppercase;
    padding: 0 32px;
    border-radius: 6px;
    margin-top: 16px;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
`;

export const DiscardButton = styled(SaveButton)`
    background-color: unset;
    color: ${({ theme }) => theme.colors.gray};
`;

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;
